export const SOCKET_URL = '/';
